<app-top-nav></app-top-nav>

<div class="main-content">
  <router-outlet></router-outlet>
</div>
